/****************************************************
 * Module Name:  nivodaProxy.js
 * Project:      Pansuriya Impex Sales & Manufacturing
 * Owner:        info@pansuriyaimpex.com
 *
 * Copyright (c) Pansuriya Impex
 * All rights reserved.
 ****************************************************/

import restAPICall from "../../api/restAPICall";
import Constants from "../../constants";

export default class NivodaProxy {

    static updateStones = (revisedStoneList, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/nivoda/updatestone",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(revisedStoneList),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetPricePreview = (reqParam, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/nivoda/price/preview",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(reqParam),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static RevertPrice = (reqParam, callback) => {
        restAPICall(
            Constants.MANAGER_URL + "/nivoda/updatestone/price",
            "post",
            Constants.userToken,
            undefined,
            JSON.stringify(reqParam),
            "application/json",
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetNivodaStockByStoneType = (stoneType, todate, stockPattern, callback) => {
        let params = {
            stonetype: stoneType,
            iteration: todate,
            stockpattern: stockPattern
        };

        restAPICall(
            Constants.UTILITY_URL + "/nivoda/stock",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };

    static GetNivodaStockByStoneId = (stoneid, callback) => {
        let params = { stoneid: stoneid };

        restAPICall(
            Constants.UTILITY_URL + "/nivoda/stock",
            "get",
            Constants.userToken,
            params,
            undefined,
            undefined,
            0
        )
            .then((response) => callback(response))
            .catch((error) => {
                callback(undefined);
            });
    };


}